import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './LandingPage';
import { ProgramPage } from './ProgramPage';
import { AuthModal } from './auth/AuthModal';
import { PublicRegistration } from './PublicRegistration';
import { Branch, ProgramPrice } from '../types/db';
import { supabase } from '../lib/supabaseClient';

export const PublicLayout: React.FC = () => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isRegModalOpen, setIsRegModalOpen] = useState(false);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [programPrices, setProgramPrices] = useState<ProgramPrice[]>([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [{ data: bData }, { data: pData }] = await Promise.all([
          supabase.from('branches').select('*'),
          supabase.from('program_prices').select('*'),
        ]);

        if (bData) {
          /* console removed */
          setBranches(bData);
        }
        if (pData) setProgramPrices(pData);
      } catch (err) {
        /* console removed */
      }
    };
    loadData();
  }, []);

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <LandingPage
              branches={branches}
              onLoginClick={() => setIsAuthModalOpen(true)}
              onRegisterClick={() => setIsRegModalOpen(true)}
            />
          }
        />
        <Route
          path="/program"
          element={
            <ProgramPage branches={branches} onRegisterClick={() => setIsRegModalOpen(true)} />
          }
        />
      </Routes>

      <AuthModal isOpen={isAuthModalOpen} onClose={() => setIsAuthModalOpen(false)} />

      {isRegModalOpen && (
        <PublicRegistration
          branches={branches}
          programPrices={programPrices}
          onClose={() => setIsRegModalOpen(false)}
          onRegister={() => {
            setIsRegModalOpen(false);
            window.alert('Pendaftaran berhasil dikirim! Silakan tunggu konfirmasi admin.');
          }}
        />
      )}
    </>
  );
};
